module.exports = __webpack_public_path__ + "static/offer-16c73a85ecba36e45a6daeb4f24af417.jpg";